import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './styled';

import CardSummary from '../cards/CardSummary';

import srcPayment from '../assets/payment.svg';
import srcPaymentMobile from '../assets/payment-mobile.svg';
import srcPaymentTablet from '../assets/payment-tablet.svg';

import srcPaymentCheck from '../assets/payment-check.svg';
import srcPaymentCheckMobile from '../assets/payment-check-mobile.svg';
import srcPaymentCheckTablet from '../assets/payment-check-tablet.svg';

import ReusableButton from '../../../../../../reusables/Button';
import ReusableCard from '../../../../../../reusables/Card';
import ReusableTitle from '../../../../../../reusables/Title';
import ReusableInfo from '../../../../../../reusables/Info';
import ActivatePayment from '../dialogs/ActivatePayment';
import PaymentCreated from '../dialogs/PaymentCreated';

interface IProps {
  active: boolean;
  complete: boolean;
  option: number;
  activatePayment: () => void;
  isSuccessActivatePayment: boolean;
  clearActivatePayment: () => void;
  periodsSelected?: string;
  infoText?: string;
  dateOfPayment?: string;
}

const StepPayment = ({
  active,
  complete,
  option,
  activatePayment,
  isSuccessActivatePayment,
  clearActivatePayment,
  periodsSelected,
  infoText,
  dateOfPayment
}: IProps) => {
  const options = [
    {
      src: srcPayment,
      srcMobile: srcPaymentMobile,
      srcTablet: srcPaymentTablet
    },
    {
      src: srcPaymentCheck,
      srcMobile: srcPaymentCheckMobile,
      srcTablet: srcPaymentCheckTablet
    }
  ];

  const [selected, setSelected] = useState(options[0]);
  const [activatePaymentModal, setActivatePaymentModal] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setSelected(options[option]);
  }, [option]);

  return (
    <>
      {active ? (
        <>
          <ReusableCard padding="24px 24px 24px 24px">
            <S.Payment>
              <div>
                <picture>
                  <source srcSet={selected.src} media="(min-width: 768px)" />
                  <source
                    srcSet={selected.srcTablet}
                    media="(min-width: 640px)"
                  />
                  <img src={selected.srcMobile} alt="selected" />
                </picture>
              </div>
              <div>
                <ReusableTitle
                  fontSize="18px"
                  fontWeight="900"
                  lineHeight="28px"
                  title={
                    option > 0
                      ? 'El pago ha sido activado.'
                      : 'Genera el cargo de tu trámite activando tu pago'
                  }
                  textAling
                />
                <ReusableInfo
                  style={{ marginTop: '12px' }}
                  text={infoText || StepPayment.defaultProps.infoText}
                />
                <ReusableButton
                  text={option > 0 ? 'Ir a pagos' : 'Activar'}
                  style={{ marginTop: '32px' }}
                  onClick={() =>
                    option > 0
                      ? history.push(`/pagos`)
                      : setActivatePaymentModal(true)
                  }
                />
              </div>
            </S.Payment>
          </ReusableCard>
          {/* MODALES - DIALOGS */}
          {periodsSelected && (
            <ActivatePayment
              show={activatePaymentModal}
              handlerOnNext={() => {
                activatePayment();
                setActivatePaymentModal(false);
              }}
              handlerClose={() => {
                setActivatePaymentModal(false);
              }}
              periodsSelected={periodsSelected.split('-').length}
            />
          )}
          <PaymentCreated
            show={isSuccessActivatePayment}
            handlerOnNext={() => history.push(`/pagos`)}
            handlerClose={clearActivatePayment}
          />
        </>
      ) : complete ? (
        <CardSummary title={dateOfPayment ?? ''} />
      ) : (
        ''
      )}
    </>
  );
};

StepPayment.defaultProps = {
  infoText:
    'Recuerda que una vez realizado el pago podrás descargar tu certificado.'
};

export default StepPayment;
